import * as React from 'react';

import moment from 'moment';

import {formatDateForHeader} from './format-date-for-header';

import styles from './date-header.module.css';

type Props = {
    /** Inline style object for an escape hatch */
    style?: any;
    /** UNIX timestamp */
    date?: number;
    /** Render children if `date` prop is not provided */
    children?: React.ReactNode;
    /** moment format to fall back to on days other than yesterday, today, and tomorrow */
    customFormat?: string;
};

/**
 * Provides a formatted date string and bottom border.  Used so far in the dashboard
 * sidebar and queued email lists.
 */
export class DateHeader extends React.PureComponent<Props> {
    render() {
        if (this.props.date) {
            const date = moment.unix(this.props.date);
            const formattedDate = formatDateForHeader(date, this.props.customFormat);

            return (
                <div style={this.props.style} className={styles['date-header']}>
                    <span>{formattedDate}</span>
                </div>
            );
        } else {
            return (
                <div style={this.props.style} className={styles['date-header']}>
                    <span>{this.props.children}</span>
                </div>
            );
        }
    }
}
